const state = {
  routes: [],
  openTabs: [],
  activeIndex: '', //激活状态
};
const mutations = {
  // 添加tabs
  ADD_TAB (state, data) {
    let isHave = false
    for (let i = 0; i < state.openTabs.length; i++) {
      if (state.openTabs[i].route == data.route && state.openTabs[i].name == data.name) {
        isHave = true
        break;
      }
    }
    if (!isHave) {
      if (state.openTabs.length === 5) {
        state.openTabs.splice(1, 1)
      }
      state.openTabs.push(data);
    }
  },
  //设置opentabs 为空
  SET_DEFAT_OPENTABS (state) {
    state.openTabs = [];
    state.routes = [];
    state.activeIndex = '';
  },
  // 删除tabs
  DEL_TAB (state, route) {
    let index = 0;
    for (let option of state.openTabs) {
      if (option.route === route) {
        break;
      }
      index++;
    }
    state.openTabs.splice(index, 1);
  },
  SET_TAB_DATA (state, data) {
    state.openTabs = data;
  },
  // 设置当前激活的tab
  SET_ACTIVE_INDEX (state, index) {
    state.activeIndex = index;
  },
};
const actions = {};
const getters = {};

// 不要忘记把state, mutations等暴露出去。
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}